import React, { useState } from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import { Formik } from 'formik'
import { FormControlLabel, Checkbox, Tooltip } from '@material-ui/core'
import { semiConfigContext } from '../Crisprgna'
import ProductDetailsLink from '@src/routes/SemiConfigurators/components/ProductDetailsLink'
import { ReagentsItem, initialState } from '../Reducer'
import { FormattedMessage } from 'react-intl'
import messages from '../../../messages'
import { cloneDeep } from 'lodash'
import { SpecificationMessages } from '../Enum'
import TableContainer from '@material-ui/core/TableContainer'
import InfoIcon from '@material-ui/icons/Info'

interface Column {
  id:
    | 'MISSIONID'
    | 'Category'
    | 'GeneSym'
    | 'GeneID'
    | 'Efficiency'
    | 'Specificity'
    | 'Species'
    | 'EmptyLabel'
  label: any
  minWidth?: number
  align?: 'right'
  format?: (value: number) => string
}

const columns: Column[] = [
  {
    id: 'MISSIONID',
    label: (
      <FormattedMessage {...messages.CONF_MISSION_GRNA_ID_LABEL_crispgrna} />
    ),
    minWidth: 120,
  },
  {
    id: 'Category',
    label: <FormattedMessage {...messages.CONF_GRNA_CATEGORY_crispgrna} />,
    minWidth: 100,
  },
  {
    id: 'GeneSym',
    label: <FormattedMessage {...messages.CONF_GENE_SYM_LABEL_crispgrna} />,
    minWidth: 80,
  },
  {
    id: 'GeneID',
    label: <FormattedMessage {...messages.CONF_GENE_ID_LABEL_crispgrna} />,
    minWidth: 70,
  },
  {
    id: 'Efficiency',
    label: (
      <FormattedMessage {...messages.CONF_EFFICIENCY_SCORE_LABEL_crispgrna} />
    ),
    minWidth: 60,
  },
  {
    id: 'Specificity',
    label: (
      <FormattedMessage
        {...messages.CONF_SPECIFICATION_SCORE_LABEL_crispgrna}
      />
    ),
    minWidth: 50,
  },
  {
    id: 'Species',
    label: <FormattedMessage {...messages.CONF_SPECIES_LABEL_crispgrna} />,
    minWidth: 40,
  },
  { id: 'EmptyLabel', label: ' ', minWidth: 60 },
]

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      width: '100%',
      paddingRight: theme.spacing(5),
      paddingLeft: theme.spacing(3.5),
      borderRadius: theme.spacing(0),
    },
    errorMsgStyle: {
      paddingBottom: theme.spacing(2.5),
      paddingTop: theme.spacing(4),
      textAlign: 'center',
      fontSize: theme.typography.pxToRem(16),
      borderRadius: theme.spacing(0),
    },
    container: {
      maxHeight: 440,
    },
    tableContainer: {
      maxHeight: 850,
      '& .MuiTableCell-root': {
        padding: theme.spacing(4, 1.5),
      },
    },
    fontBold: {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightMedium,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'justify',
    },
    lightGreyFont: {
      fontSize: theme.typography.pxToRem(12),
    },
    lightGreyFontPad: {
      paddingRight: theme.spacing(19.5),
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightMedium,
    },
    lightGreyFontSub: {
      marginLeft: theme.spacing(-222.5),
      marginTop: theme.spacing(28),
    },
    tableHead: {
      fontSize: theme.typography.pxToRem(12),
    },
    dropDown: {
      '& .MuiSelect-select': {
        fontSize: theme.typography.pxToRem(12),
      },
      textAlign: 'center',
    },
    tableBorderBottom: {
      borderBottom: 0,
    },
    textAign: {
      textAlign: 'center',
    },
    hideRow: {
      display: 'none',
      fontWeight: theme.typography.fontWeightMedium,
      color: '#535353',
    },
    detailsStyle: {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightMedium,
      paddingLeft: theme.spacing(8),
    },
    detailsStyleValue: {
      fontSize: theme.typography.pxToRem(12),
      paddingLeft: theme.spacing(1),
    },
    detailsBorderBottom: {
      borderBottom: theme.spacing(0),
      paddingBottom: theme.spacing(0),
    },
    detailsStyleSubValue: {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightMedium,
      paddingLeft: theme.spacing(0),
    },
    InfoPopup: {
      maxWidth: theme.spacing(150),
      backgroundColor: theme.palette.common.white,
      position: 'relative',
      boxShadow: theme.shadows[4],
      padding: theme.spacing(5),
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.common.black,
      borderRadius: '2%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    InfoIcon: {
      position: 'relative',
      fontSize: theme.typography.pxToRem(16),
      top: theme.spacing(0.5),
      marginLeft: theme.spacing(1.5),
    },
    arrow1: {
      color: theme.palette.common.white,
    },
    tableHeadCategory: {
      fontSize: theme.typography.pxToRem(12),
    },
  }
})

const PreDesignedControl = () => {
  const classes = useStyles()
  const { state, dispatch } = React.useContext(semiConfigContext)
  const { searchResponseJson } = state
  const [detailsExpanded, setDetailsExpanded] = useState(
    Array(searchResponseJson.controls.length).fill(false)
  )

  let detailsToggle: any = []
  const [isAllChecked, setIsAllChecked] = React.useState(false)
  React.useEffect(() => {
    detailsToggle = false
    setDetailsExpanded(detailsToggle)

    // TODO: need a test before we refactor these dependencies
  }, [state.setPage])
  const handleDetailsClick = (e: React.MouseEvent, index) => {
    e.preventDefault()
    detailsToggle = Array(searchResponseJson.controls.length).fill(false)
    detailsToggle[index] = true
    if (detailsExpanded[index]) {
      detailsToggle[index] = false
    }
    setDetailsExpanded(detailsToggle)
  }

  const setInitialState = () => {
    dispatch({ type: 'TRACE_ON_CLICK', data: true })
    dispatch({
      type: 'UPDATE_DROP_DOWN',
      data: initialState.dropDownValue,
    })
    dispatch({
      type: 'UPDATE_DROPDOWN_RESPONSE',
      data: initialState.dropDownResponseList,
    })
    dispatch({
      type: 'UPDATE_PRICE_CALL_RESPONSE',
      data: initialState.priceCallResponse,
    })
    dispatch({
      type: 'UPDATE_DROP_DOWN',
      data: initialState.dropDownValue,
    })
    dispatch({
      type: 'UPDATE_PRICE_CALL',
      data: initialState.priceCallData,
    })
    dispatch({
      type: 'UPDATE_SPECIFICATION_VALUES',
      data: initialState.specificationValues,
    })
  }

  const getCategoryHelpTexts = () => {
    const helpIconPointsList: any[] = []
    for (let i = 1; i <= 6; i++) {
      helpIconPointsList.push(
        <ul>
          <li>
            <FormattedMessage
              {...messages[
                `SEMICONF_HELP_ICON_TEXT_CATEGORY_POINT${i}_crisprgrna`
              ]}
            />
          </li>
        </ul>
      )
    }
    return helpIconPointsList
  }

  const checkSelectedGrna = (item) => {
    let isChecked = false
    state.priceCallData.reagents.some((reagent) => {
      if (reagent.grnaId === item.grnaId) {
        isChecked = true
        return true
      }
      return null
    })
    return isChecked
  }

  const onChangeControls = (item: ReagentsItem) => {
    if (state.stepNo !== 1) {
      setInitialState()
    }
    let grnaList: ReagentsItem[] = cloneDeep(state.priceCallData.reagents)

    if (!checkSelectedGrna(item) && item.grnaId) {
      grnaList.push(item)

      const reagents = grnaList.filter(
        (i) => i.recommendedStatus === SpecificationMessages.Control
      )

      if (searchResponseJson.controls.length === reagents.length) {
        setIsAllChecked(true)
      }
    } else if (item.grnaId) {
      grnaList = grnaList.filter((o: ReagentsItem) => o.grnaId !== item.grnaId)

      setIsAllChecked(false)
    }

    grnaList.forEach((sc) => {
      delete sc.__typename
    })
    dispatch({
      type: 'UPDATE_PRICE_CALL',
      data: { ...state.priceCallData, reagents: [...grnaList] },
    })
  }

  const onChangeControlsAll = () => {
    if (state.stepNo !== 1) {
      setInitialState()
    }
    let grnaList: ReagentsItem[] = cloneDeep(searchResponseJson.controls)
    if (!isAllChecked && state.priceCallData.reagents.length !== 0) {
      grnaList = grnaList.concat(state.priceCallData.reagents)
    }
    grnaList.forEach((sc) => {
      delete sc.__typename
    })
    setIsAllChecked(isAllChecked ? false : true)
    const reagents = state.priceCallData.reagents.filter(
      (i) => i.recommendedStatus !== SpecificationMessages.Control
    )
    reagents.forEach((sc) => {
      delete sc.__typename
    })
    dispatch({
      type: 'UPDATE_PRICE_CALL',
      data: {
        ...state.priceCallData,
        reagents: [...(isAllChecked ? [...reagents] : [...grnaList])],
      },
    })
  }

  React.useEffect(() => {
    const grnaList: ReagentsItem[] = cloneDeep(state.priceCallData.reagents)

    const reagents = grnaList.filter(
      (i) => i.recommendedStatus === SpecificationMessages.Control
    )

    if (searchResponseJson.controls.length === reagents.length) {
      setIsAllChecked(true)
    }
  }, [])

  React.useEffect(() => {
    // Added comment for avoid es-lint error
  }, [state.priceCallData.reagents])

  const renderData = () => {
    const result: any = []
    cloneDeep(searchResponseJson.controls).map((item, index) => {
      const moreItems = { ...JSON.parse(item.moreInformation) }
      result.push(
        <TableRow hover role="checkbox" tabIndex={-1} key={index}>
          <TableCell>
            <FormControlLabel
              classes={{ label: classes.fontBold }}
              control={
                <Checkbox
                  checked={checkSelectedGrna(item)}
                  color="primary"
                  value=""
                  onChange={() => onChangeControls(item)}
                />
              }
              label={item.grnaId}
            />
          </TableCell>
          <TableCell className={classes.textAign}>
            <span className={classes.lightGreyFont}>
              {item.recommendedStatus}
            </span>
          </TableCell>
          <TableCell className={classes.textAign}>
            <span className={classes.lightGreyFont}>{item.geneSymbol}</span>
          </TableCell>
          <TableCell className={classes.textAign}>
            <span className={classes.lightGreyFont}>{item.geneId}</span>
          </TableCell>
          <TableCell className={classes.textAign}>
            <span className={classes.lightGreyFont}>
              {item.efficiencyScore}
            </span>
          </TableCell>
          <TableCell className={classes.textAign}>
            <span className={classes.lightGreyFont}>
              {item.specificityScore}
            </span>
          </TableCell>
          <TableCell className={classes.textAign}>
            <span className={classes.lightGreyFont}>{item.species}</span>
          </TableCell>
          <TableCell className={classes.dropDown}>
            <ProductDetailsLink
              onClick={(ev) => {
                handleDetailsClick(ev, index)
              }}
              detailsExpanded={detailsExpanded[index]}
            />
          </TableCell>
        </TableRow>,

        <TableRow className={detailsExpanded[index] ? '' : classes.hideRow}>
          <TableCell colSpan={4} className={classes.detailsBorderBottom}>
            <span className={classes.detailsStyle}>
              <FormattedMessage
                {...messages.SEMICONF_DETAILS_SEQUENCE_crisprgrna}
              />
            </span>
            <span className={classes.detailsStyleValue}>
              {moreItems.targetSequence}
            </span>
          </TableCell>

          <TableCell colSpan={3} className={classes.detailsBorderBottom}>
            <span className={classes.detailsStyleSubValue}>
              <FormattedMessage
                {...messages.SEMICONF_DETAILS_STRAND_crisprgrna}
              />
            </span>
            <span className={classes.detailsStyleValue}>
              {moreItems.senseAntisense}
            </span>
          </TableCell>
        </TableRow>,

        <TableRow className={detailsExpanded[index] ? '' : classes.hideRow}>
          <TableCell colSpan={4} className={classes.detailsBorderBottom}>
            <span className={classes.detailsStyle}>
              <FormattedMessage {...messages.SEMICONF_DETAILS_PAM_crisprgrna} />
            </span>
            <span className={classes.detailsStyleValue}>{moreItems.pam}</span>
          </TableCell>
          <TableCell colSpan={3} className={classes.detailsBorderBottom}>
            <span className={classes.detailsStyleSubValue}>
              <FormattedMessage
                {...messages.SEMICONF_DETAILS_TRANSCRIPTS_HIT_crisprgrna}
              />
            </span>
            <span className={classes.detailsStyleValue}>
              {moreItems.transcriptsHit}
            </span>
          </TableCell>
        </TableRow>,

        <TableRow className={detailsExpanded[index] ? '' : classes.hideRow}>
          <TableCell colSpan={4} className={classes.detailsBorderBottom}>
            <span className={classes.detailsStyle}>
              <FormattedMessage
                {...messages.SEMICONF_DETAILS_START_COORDINATE_crisprgrna}
              />
            </span>
            <span className={classes.detailsStyleValue}>
              {moreItems.startCoordinate}
            </span>
          </TableCell>
          <TableCell colSpan={3} className={classes.detailsBorderBottom}>
            <span className={classes.detailsStyleSubValue}>
              <FormattedMessage
                {...messages.SEMICONF_DETAILS_REFSEQ_crisprgrna}
              />
            </span>
            <span className={classes.detailsStyleValue}>
              {moreItems.refSeqId[0]}
            </span>
          </TableCell>
        </TableRow>,

        <TableRow className={detailsExpanded[index] ? '' : classes.hideRow}>
          <TableCell colSpan={8}>
            <span className={classes.detailsStyle}>
              <FormattedMessage
                {...messages.SEMICONF_DETAILS_CHROMOSOME_crisprgrna}
              />
            </span>
            <span className={classes.detailsStyleValue}>
              {moreItems.chromosome}
            </span>
          </TableCell>
        </TableRow>
      )
      return item
    })
    return result
  }
  return (
    <>
      <semiConfigContext.Provider value={{ state, dispatch }}>
        <Formik
          initialValues={{ DetailsSection: 'Details' }}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              actions.setSubmitting(false)
            }, 1000)
          }}
        >
          <Paper className={classes.root}>
            <TableContainer className={classes.tableContainer}>
              <Table stickyHeader aria-label="sticky table">
                <TableRow>
                  {columns.map((column, index) => {
                    if (column.id === 'MISSIONID')
                      return (
                        <TableCell
                          key={index}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                          className={classes.tableBorderBottom}
                        >
                          <FormControlLabel
                            classes={{ label: classes.fontBold }}
                            control={
                              <Checkbox
                                value=""
                                color="primary"
                                checked={isAllChecked}
                                onChange={() => onChangeControlsAll()}
                              />
                            }
                            label={column.label}
                          />
                        </TableCell>
                      )
                    else if (column.id === 'Category')
                      return (
                        <TableCell
                          key={index}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                          className={classes.tableBorderBottom}
                        >
                          <strong className={classes.tableHeadCategory}>
                            {column.label}
                            <Tooltip
                              title={
                                <React.Fragment>
                                  <div>
                                    <FormattedMessage
                                      {...messages.SEMICONF_HELP_ICON_TEXT_CATEGORY_crisprgrna}
                                    />
                                  </div>
                                  {getCategoryHelpTexts()}
                                </React.Fragment>
                              }
                              placement="bottom-end"
                              classes={{
                                tooltip: classes.InfoPopup,
                                arrow: classes.arrow1,
                              }}
                              arrow
                            >
                              <InfoIcon
                                color="primary"
                                aria-label="info"
                                className={classes.InfoIcon}
                              ></InfoIcon>
                            </Tooltip>
                          </strong>
                        </TableCell>
                      )
                    else if (column.id === 'Efficiency')
                      return (
                        <TableCell
                          key={index}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                          className={classes.tableBorderBottom}
                        >
                          <strong className={classes.tableHeadCategory}>
                            {column.label}
                            <Tooltip
                              title={
                                <React.Fragment>
                                  <div>
                                    <FormattedMessage
                                      {...messages.SEMICONF_HELP_ICON_TEXT_EFFICIENCY_crisprgrna}
                                    />
                                  </div>
                                </React.Fragment>
                              }
                              placement="bottom-end"
                              classes={{
                                tooltip: classes.InfoPopup,
                                arrow: classes.arrow1,
                              }}
                              arrow
                            >
                              <InfoIcon
                                color="primary"
                                aria-label="info"
                                className={classes.InfoIcon}
                              ></InfoIcon>
                            </Tooltip>
                          </strong>
                        </TableCell>
                      )
                    else if (column.id === 'Specificity')
                      return (
                        <TableCell
                          key={index}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                          className={classes.tableBorderBottom}
                        >
                          <strong className={classes.tableHeadCategory}>
                            {column.label}
                            <Tooltip
                              title={
                                <React.Fragment>
                                  <div>
                                    <FormattedMessage
                                      {...messages.SEMICONF_HELP_ICON_TEXT_SPECIFICITY_crisprgrna}
                                    />
                                  </div>
                                </React.Fragment>
                              }
                              placement="bottom-end"
                              classes={{
                                tooltip: classes.InfoPopup,
                                arrow: classes.arrow1,
                              }}
                              arrow
                            >
                              <InfoIcon
                                color="primary"
                                aria-label="info"
                                className={classes.InfoIcon}
                              ></InfoIcon>
                            </Tooltip>
                          </strong>
                        </TableCell>
                      )
                    return (
                      <TableCell
                        key={index}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                        className={classes.tableBorderBottom}
                      >
                        <strong className={classes.tableHead}>
                          {column.label}
                        </strong>
                      </TableCell>
                    )
                  })}
                </TableRow>
                <TableBody>{renderData()}</TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Formik>
      </semiConfigContext.Provider>
    </>
  )
}

export default PreDesignedControl
